// Russian translations
import { TranslationKeys } from './en';

export const ru: TranslationKeys = {
  // Common
  common: {
    save: 'СОХРАНИТЬ',
    close: 'ЗАКРЫТЬ',
    cancel: 'ОТМЕНА',
    delete: 'УДАЛИТЬ',
    edit: 'ИЗМЕНИТЬ',
    add: 'ДОБАВИТЬ',
    complete: 'Завершить',
    completed: 'ЗАВЕРШЕНО',
    done: 'Готово',
    create: 'СОЗДАТЬ',
    loading: 'Загрузка...',
    settings: 'НАСТРОЙКИ',
    level: 'Уровень',
    profile: 'ПРОФИЛЬ',
    step: 'Шаг',
    of: 'из',
    back: 'НАЗАД',
    next: 'ДАЛЕЕ',
  },

  // Navigation
  nav: {
    dashboard: 'Панель',
    quests: 'Квесты',
    stats: 'Статистика',
    achievements: 'Достижения',
    shop: 'Магазин',
    history: 'История',
    calendar: 'Календарь',
    focus: 'Фокус',
    passiveSkills: 'Пассивные Навыки',
    settings: 'Настройки',
    signOut: 'Выйти',
  },

  // Dashboard
  dashboard: {
    title: 'ПАНЕЛЬ ОХОТНИКА',
    subtitle: 'Отслеживайте свой прогресс и выполняйте квесты',
    systemStatus: 'Статус системы',
    name: 'Имя:',
    class: 'Класс:',
    streak: 'Серия',
    best: 'Лучшее:',
    currency: 'Валюта',
    level: 'Уровень',
    xp: 'ОПЫТ',
    createQuest: 'Создать квест',
    aiGenerator: 'ИИ генератор квестов',
    createProgram: 'ИИ программа обучения',
    dailyQuests: 'Ежедневные квесты',
    activeQuests: 'Активные квесты',
    scheduledQuests: 'Запланированные квесты',
    noQuests: 'Нет доступных квестов',
    noQuestsDesc: 'Создайте свой первый квест, чтобы начать путешествие!',
  },

  // Quests
  quests: {
    title: 'Название квеста',
    description: 'Описание',
    titlePlaceholder: 'Введите название квеста...',
    descriptionPlaceholder: 'Детали квеста...',
    questType: 'ТИП КВЕСТА',
    difficulty: 'СЛОЖНОСТЬ',
    schedule: 'ЗАПЛАНИРОВАТЬ НА (ОПЦИОНАЛЬНО)',
    scheduleDesc: 'Оставьте пустым для немедленной доступности или выберите будущую дату',
    subTasks: 'ПОДЗАДАЧИ / ЧЕКЛИСТ (ОПЦИОНАЛЬНО)',
    addSubTask: 'Добавить подзадачу...',
    enhanced: 'Улучшенный',
    rewards: 'Награды',
    status: 'Статус',
    main: 'Основной',
    side: 'Побочный',
    daily: 'Ежедневный',
    boss: 'Босс',
    instant: 'Мгновенный',
  },

  // Quest Edit Modal
  questEdit: {
    questDetails: 'Детали квеста',
    completed: 'ВЫПОЛНЕНО',
    close: 'Закрыть',
    questTitle: 'Название квеста',
    noDescription: 'Нет описания',
    calendarColor: 'Цвет календаря',
    scheduledTime: 'Запланированное время',
    startTime: 'Время начала',
    endTime: 'Время окончания',
    rewards: 'Награды',
    willUpdateOnSave: 'Обновится при сохранении',
    xp: 'ОПЫТ',
    gold: 'Золото',
    stats: 'Характеристики',
    cancel: 'Отмена',
    saveChanges: 'Сохранить изменения',
    complete: 'Завершить',
    edit: 'Редактировать',
    delete: 'Удалить',
    confirmDelete: 'Вы уверены, что хотите удалить этот квест?',
    dailyReset: 'Ежедневный сброс',
    resetDaily: 'Сбрасывать этот квест ежедневно',
    resetDailyDescription: 'Квест будет сбрасываться в активное состояние каждый день после выполнения',
    oneTimeDescription: 'Квест останется выполненным после завершения',
    dailyResetStatus: 'Сбрасывается ежедневно',
    oneTimeStatus: 'Одноразовый квест',
    dailyResetTooltip: 'Идеально для ежедневных привычек и рутин',
    oneTimeTooltip: 'Отлично для одноразовых задач и проектов',
    colorTooltip: 'Выбор "По умолчанию" автоматически использует цвет типа квеста',
    colors: {
      default: 'По умолчанию (Тип)',
      shadowBlue: 'Теневой синий',
      monarchPurple: 'Королевский фиолетовый',
      emeraldGreen: 'Изумрудно-зелёный',
      bloodRed: 'Кроваво-красный',
      goldMonarch: 'Золотой монарх',
      iceCrystal: 'Ледяной кристалл',
      pinkMagic: 'Розовая магия',
      darkVoid: 'Тёмная бездна',
    },
  },

  // Difficulty levels
  difficulty: {
    easy: 'E-Rank (Легко)',
    normal: 'C-Rank (Нормально)',
    hard: 'A-Rank (Сложно)',
    veryHard: 'A-Rank (Очень сложно)',
    boss: 'S-Rank (Босс)',
  },

  // Settings
  settings: {
    title: 'НАСТРОЙКИ',
    subtitle: 'Настройте свой опыт охотника',
    profile: 'ПРОФИЛЬ',
    preferences: 'ПРЕДПОЧТЕНИЯ',
    appearance: 'ВНЕШНИЙ ВИД',
    account: 'АККАУНТ',
    save: 'СОХРАНИТЬ',
    replayTutorial: 'Повторить обучение',
    replayTutorialDesc: 'Перезапустить руководство',
    playerName: 'Имя игрока',
    namePlaceholder: 'Введите ваше имя...',
    title_label: 'Титул',
    audio: 'АУДИО',
    masterAudio: 'Основной звук',
    masterAudioDesc: 'Включить/выключить все звуки',
    systemVoice: 'Системный голос',
    systemVoiceDesc: 'Эпические голосовые реплики для достижений',
    voiceVolume: 'Громкость голоса',
    voiceVolumeDesc: 'Настройте громкость голосовых реплик',
    sfxVolume: 'Громкость звуковых эффектов',
    sfxVolumeDesc: 'Настройте звуковые эффекты интерфейса и действий',
    backgroundMusic: 'Фоновая музыка',
    backgroundMusicDesc: 'Включить окружающую музыку при использовании приложения',
    musicTheme: 'Музыкальная тема',
    musicThemeDesc: 'Выберите фоновую музыку',
    musicVolume: 'Громкость музыки',
    musicVolumeDesc: 'Настройте громкость фоновой музыки',
    test: 'ТЕСТ',
    gameplay: 'ГЕЙМПЛЕЙ',
    xpMultiplier: 'Множитель опыта',
    xpMultiplierDesc: 'Настройте скорость получения опыта',
    hard: '(Сложно)',
    normal: '(Нормально)',
    easy: '(Легко)',
    theme: 'ТЕМА ОБОЕВ',
    themeDesc: 'Выберите фоновую тему, вдохновленную Solo Leveling',
    language: 'ЯЗЫК',
    languageDesc: 'Выберите предпочитаемый язык',
    english: 'Английский',
    russian: 'Русский',
    howItWorks: 'Как это работает:',
    howItWorksDesc: 'Выбранная тема будет применена в качестве фона во всём приложении с соответствующими цветовыми схемами.',
    addImagesDesc: 'Добавьте изображения из Solo Leveling в папку',
    addImagesDesc2: 'с именами типа:',
    settingsSaved: 'Настройки сохранены!',
  },

  // Programs
  programs: {
    title: 'ИИ ПРОГРАММЫ ОБУЧЕНИЯ',
    subtitle: 'Структурированные пути обучения, созданные ИИ',
    activePrograms: 'Активные программы',
    noPrograms: 'Нет активных программ',
    noProgramsDesc: 'Создайте программу обучения с помощью ИИ, чтобы начать!',
    createProgram: 'Создать программу',
    viewRoadmap: 'Посмотреть план',
    pause: 'Пауза',
    resume: 'Возобновить',
    delete: 'Удалить',
    progress: 'Прогресс',
    duration: 'Длительность',
    days: 'дней',
    questsCompleted: 'Квестов выполнено',
  },

  // AI Generator Selector
  aiSelector: {
    title: 'ИИ ГЕНЕРАТОР',
    subtitle: 'Выберите инструмент продуктивности на основе ИИ',
    questGenerator: {
      title: 'Генератор квестов',
      description: 'Мгновенно генерируйте отдельные квесты с помощью ИИ. Идеально для быстрого создания задач с умными предложениями и ресурсами.',
      useCase: 'Подходит для: Создания 1-5 отдельных квестов',
    },
    programGenerator: {
      title: 'Программа обучения',
      description: 'Создавайте комплексные многонедельные программы обучения с ежедневными запланированными квестами. ИИ разрабатывает полный путь обучения, адаптированный под ваши цели.',
      useCase: 'Подходит для: Долгосрочных целей, требующих структурированного планирования',
    },
    footer: '',
  },

  // AI Generator
  aiGenerator: {
    questTitle: 'ГЕНЕРАТОР КВЕСТОВ ИИ',
    questSubtitle: 'Позвольте ИИ создать персонализированные квесты для вас',
    programTitle: 'СОЗДАТЬ ПРОГРАММУ ОБУЧЕНИЯ ИИ',
    programSubtitle: 'Персонализированный план, созданный ИИ',
    yourGoal: 'Чего вы хотите достичь?',
    goalPlaceholder: 'Например: Изучить JavaScript, Создать портфолио, Стать здоровым...',
    questType: 'Тип квеста',
    numberOfQuests: 'Количество квестов',
    generate: 'СГЕНЕРИРОВАТЬ КВЕСТЫ',
    generating: 'ГЕНЕРАЦИЯ...',
    generated: 'Квесты, созданные ИИ',
    selected: 'выбрано',
    generateNew: 'Создать новые',
    acceptSelected: 'ПРИНЯТЬ ВЫБРАННЫЕ',
    configureAPI: 'Настройте API ключ в настройках',
    error: 'Ошибка генерации. Проверьте API ключ.',
    // Program creation
    programGoal: 'Цель программы',
    programGoalPlaceholder: 'Например: Освоить Python, Научиться играть на гитаре, Фитнес...',
    programDuration: 'Длительность программы (дней)',
    scheduleType: 'Тип расписания',
    scheduleDaily: 'Ежедневно',
    scheduleWeekly: 'Еженедельно',
    scheduleCustom: 'Пользовательское',
    customDays: 'Пользовательские дни',
    questsPerDay: 'Квестов в день',
    intensity: 'Уровень интенсивности',
    intensityLight: 'Легкий',
    intensityModerate: 'Умеренный',
    intensityIntense: 'Интенсивный',
    personalization: 'ПЕРСОНАЛИЗАЦИЯ (ОПЦИОНАЛЬНО)',
    skillLevel: 'Ваш текущий уровень навыков',
    skillBeginner: 'Начинающий',
    skillIntermediate: 'Средний',
    skillAdvanced: 'Продвинутый',
    timePerDay: 'Доступное время в день',
    learningStyle: 'Предпочитаемый стиль обучения',
    learningStylePlaceholder: 'Например: Практические проекты, Чтение документации, Видео...',
    specificFocus: 'Конкретные цели/фокус',
    specificFocusPlaceholder: 'Например: Фокус на веб-разработке, создание проекта портфолио...',
    availableResources: 'Доступные ресурсы',
    availableResourcesPlaceholder: 'Например: Гитара, ноутбук, абонемент в спортзал...',
    generateProgram: 'СОЗДАТЬ ПРОГРАММУ',
    generatingProgram: 'СОЗДАНИЕ ПРОГРАММЫ...',
    programCreating: 'Создаем ваш персонализированный план обучения...',
    // Step 1
    whatsYourGoal: 'Какова ваша цель?',
    goalMin: 'Введите цель (мин. 4 символа) и выберите продолжительность не менее 7 дней.',
    characters: 'символов',
    weeks: 'недель',
    week: 'неделя',
    year: 'год',
    // Step 2
    trainingSchedule: 'Расписание тренировок',
    schedEveryDay: 'Каждый день',
    schedEveryDayDesc: 'Максимальный прогресс',
    sched5xWeek: '5 раз в неделю',
    sched5xWeekDesc: 'Только будни',
    sched3xWeek: '3 раза в неделю',
    sched3xWeekDesc: 'Пн / Ср / Пт',
    sched2xWeek: '2 раза в неделю',
    sched2xWeekDesc: 'Вт / Чт',
    schedEveryOther: 'Через день',
    schedEveryOtherDesc: 'Чередующиеся дни',
    schedWeekends: 'Только выходные',
    schedWeekendsDesc: 'Сб / Вс',
    schedCustom: 'Пользовательское расписание',
    schedCustomDesc: 'Выберите конкретные дни',
    selectActiveDays: 'Выберите активные дни:',
    minutes: 'минут',
    intensityDesc: {
      light: '15-20 мин/день, легкий темп',
      moderate: '30-45 мин/день, стабильный прогресс',
      intense: '60-90 мин/день, быстрый прогресс',
    },
    // Step 3
    personalizeJourney: 'Персонализируйте ваше путешествие',
    personalizeDesc: 'Помогите нашему ИИ создать идеальный план с ресурсами, примерами и советами специально для вас!',
    currentSkillLevel: 'Текущий уровень навыков',
    learningStyleOptional: 'Стиль обучения (опционально)',
    specificFocusOptional: 'Конкретный фокус (опционально)',
    availableResourcesOptional: 'Доступные ресурсы (опционально)',
    availableResourcesPlaceholder2: 'Например: У меня есть Duolingo, учебники или другие инструменты...',
    specificFocusPlaceholder2: 'Например: Разговорные навыки, основы грамматики, проекты...',
  },

  // Focus Timer
  focus: {
    title: 'ТАЙМЕР ФОКУСА',
    subtitle: 'Сохраняйте концентрацию и получайте награды',
    work: 'РАБОТА',
    break: 'ПЕРЕРЫВ',
    focusTime: 'Время фокуса',
    breakTime: 'Время перерыва',
    start: 'СТАРТ',
    pause: 'ПАУЗА',
    reset: 'СБРОС',
    rewardsPerSession: 'Награды за сеанс',
  },

  // Achievements
  achievements: {
    title: 'ДОСТИЖЕНИЯ',
    subtitle: 'Ваши достижения охотника',
    unlocked: 'Разблокировано',
    locked: 'Заблокировано',
    progress: 'Прогресс',
    all: 'Все',
    combat: 'Бой',
    progression: 'Прогрессия',
    special: 'Особые',
  },

  // Shop
  shop: {
    title: 'МАГАЗИН',
    subtitle: 'Тратьте свою заработанную валюту',
    balance: 'Ваш баланс',
    themes: 'Темы',
    titles: 'Титулы',
    owned: 'КУПЛЕНО',
    equip: 'ЭКИПИРОВАТЬ',
    equipped: 'ЭКИПИРОВАНО',
    purchase: 'КУПИТЬ',
    notEnough: 'Недостаточно золота!',
  },

  // Notifications
  notifications: {
    questComplete: 'Квест выполнен!',
    levelUp: 'Повышение уровня!',
    achievementUnlocked: 'Достижение разблокировано!',
    programCreated: 'Программа создана!',
    penaltyWarning: 'Штраф за ежедневный квест!',
    dailyReward: 'Ежедневная награда получена!',
  },

  // History
  history: {
    title: 'ИСТОРИЯ КВЕСТОВ',
    subtitle: 'Ваши выполненные и проваленные квесты',
    completedQuests: 'Выполненные квесты',
    noHistory: 'История квестов пока пуста',
    completedOn: 'Выполнено',
    earnedRewards: 'Полученные награды',
    currentCurrency: 'Текущая валюта',
    earned: 'Заработано',
    bossDefeated: 'Боссов повержено',
    byDifficulty: 'ПО СЛОЖНОСТИ',
    byType: 'ПО ТИПУ',
  },

  // Stats
  stats: {
    title: 'СТАТИСТИКА',
    subtitle: 'Отслеживайте свой путь продуктивности',
    days7: '14 ДНЕЙ',
    days30: '30 ДНЕЙ',
    level: 'Уровень',
    quests: 'Квесты',
    totalXP: 'Всего XP',
    currentCurrency: 'Текущая валюта',
    earnedFromQuests: 'Заработано квестами:',
    hunterStatsAnalysis: 'АНАЛИЗ ХАРАКТЕРИСТИК ОХОТНИКА',
    systemInterface: '［ Системный интерфейс ］',
    xpProgression: 'ПРОГРЕСС XP',
    questActivity: 'АКТИВНОСТЬ КВЕСТОВ',
    focusDuration: 'ДЛИТЕЛЬНОСТЬ ФОКУСА',
    wealthAccumulation: 'НАКОПЛЕНИЕ БОГАТСТВА',
    // Player stats
    strength: 'СИЛА',
    intelligence: 'ИНТЕЛЛЕКТ',
    agility: 'ЛОВКОСТЬ',
    vitality: 'ЖИВУЧЕСТЬ',
    sense: 'ЧУВСТВО',
    allocate: 'РАСПРЕДЕЛИТЬ ХАРАКТЕРИСТИКИ',
    allocateDesc: 'Выполняйте квесты, чтобы заработать очки характеристик',
    unallocated: 'Нераспределенные очки',
    completed: 'Выполнено',
    failed: 'Провалено',
    streak: 'Серия дней',
  },

  // Onboarding
  onboarding: {
    intro: {
      title: 'ИНИЦИАЛИЗАЦИЯ СИСТЕМЫ',
      message: 'Приветствую, Игрок. Система выбрала вас для путешествия самосовершенствования. Выполняйте квесты, повышайте характеристики и становитесь лучшей версией себя. Ваше преображение начинается сейчас...',
      skip: 'Пропустить введение',
    },
    steps: {
      stats: {
        title: 'Характеристики охотника',
        description: 'Отслеживайте свой уровень, прогресс XP и атрибуты персонажа. Выполняйте квесты, чтобы зарабатывать XP и повышать уровень. Распределяйте очки характеристик для усиления способностей: СИЛА, ИНТЕЛЛЕКТ, ЛОВКОСТЬ, ЖИВУЧЕСТЬ и ЧУВСТВО.',
      },
      quests: {
        title: 'Система квестов',
        description: 'Создавайте квесты вручную или используйте генерацию ИИ. Типы квестов: Ежедневные (сбрасываются ежедневно), Основные (важные цели), Мгновенные (быстрые задачи) и Босс (высшие вызовы). Каждый имеет разные ранги сложности от E до S.',
      },
      aiGenerator: {
        title: 'Инструменты ИИ',
        description: 'Позвольте ИИ помочь вам! Генератор квестов мгновенно создает отдельные задачи. Программа обучения строит комплексные многонедельные пути обучения. Идеально, когда нужны умные предложения.',
      },
      sidebar: {
        title: 'Центр навигации',
        description: 'Доступ ко всем функциям: Таймер фокуса для Pomodoro-сессий, Календарь для отслеживания активности, Статистика для анализа прогресса, История выполненных квестов, Достижения, Магазин и Настройки.',
      },
      level: {
        title: 'Уровень и валюта',
        description: 'Отслеживайте свой ранг охотника и прогресс уровня. Зарабатывайте валюту, выполняя квесты, чтобы разблокировать предметы в магазине и настроить свой опыт.',
      },
    },
    actions: {
      skip: 'Пропустить обучение',
      finish: 'Начать путешествие',
    },
  },

  // Calendar
  calendar: {
    title: 'КАЛЕНДАРЬ АКТИВНОСТИ',
    subtitle: 'Отслеживайте свой путь продуктивности',
    currentStreak: 'Текущая серия',
    longestStreak: 'Самая длинная серия',
    thisMonth: 'В этом месяце',
    days: 'дней',
    prev: 'НАЗАД',
    next: 'ВПЕРЁД',
    less: 'Меньше',
    more: 'Больше',
    active: 'Активные',
    scheduled: 'Запланированные',
    completed: 'Завершенные',
    failed: 'Проваленные',
    quests: 'Квесты',
    xpEarned: 'Получено XP',
    currency: 'Валюта',
    focusMin: 'Фокус (мин)',
    noActivity: 'Нет активности в этот день',
    weekDays: {
      sun: 'Вс',
      mon: 'Пн',
      tue: 'Вт',
      wed: 'Ср',
      thu: 'Чт',
      fri: 'Пт',
      sat: 'Сб',
    },
    weekDaysFull: {
      sunday: 'Воскресенье',
      monday: 'Понедельник',
      tuesday: 'Вторник',
      wednesday: 'Среда',
      thursday: 'Четверг',
      friday: 'Пятница',
      saturday: 'Суббота',
    },
    weekDaysShort: {
      sun: 'В',
      mon: 'П',
      tue: 'В',
      wed: 'С',
      thu: 'Ч',
      fri: 'П',
      sat: 'С',
    },
    monthsShort: {
      jan: 'Янв',
      feb: 'Фев',
      mar: 'Мар',
      apr: 'Апр',
      may: 'Май',
      jun: 'Июн',
      jul: 'Июл',
      aug: 'Авг',
      sep: 'Сен',
      oct: 'Окт',
      nov: 'Ноя',
      dec: 'Дек',
    },
    monthsFull: {
      january: 'Январь',
      february: 'Февраль',
      march: 'Март',
      april: 'Апрель',
      may: 'Май',
      june: 'Июнь',
      july: 'Июль',
      august: 'Август',
      september: 'Сентябрь',
      october: 'Октябрь',
      november: 'Ноябрь',
      december: 'Декабрь',
    },
    month: 'Месяц',
    week: 'Неделя',
    day: 'День',
    backToMonth: 'Вернуться к месяцу',
    selectDayFirst: 'Пожалуйста, сначала выберите день из месячного вида',
    viewToday: 'Посмотреть сегодня',
    unscheduledQuests: 'Незапланированные квесты',
  },

  // Passive Skills
  passiveSkills: {
    title: 'ПАССИВНЫЕ НАВЫКИ',
    subtitle: 'Создавайте устойчивые привычки для разблокировки постоянных бонусов к характеристикам',
    newSkill: '+ Новый навык',
    activeBoosts: 'Активные пассивные бонусы',
    filter: 'Фильтр:',
    showPaused: 'Показать приостановленные',
    loading: 'Загрузка ваших пассивных навыков...',
    noSkills: 'Пока нет пассивных навыков',
    noSkillsCategory: 'Навыки категории {category} не найдены. Попробуйте другую категорию или создайте новый навык.',
    noSkillsDesc: 'Начните создавать устойчивые привычки, создав свой первый пассивный навык!',
    createFirst: 'Создать первый навык',
    // Categories
    all: 'Все',
    physical: 'Физические',
    mental: 'Умственные',
    social: 'Социальные',
    spiritual: 'Духовные',
    productivity: 'Продуктивность',
    // Card
    paused: 'Приостановлено',
    level: 'Уровень',
    max: 'МАКС',
    streak: 'Серия',
    best: 'Лучшее:',
    total: 'Всего:',
    boost: 'Бонус',
    thisWeek: 'На этой неделе',
    completionHistory: 'История выполнений',
    complete: '✓ Выполнить',
    doneToday: '✓ Сделано сегодня',
    notScheduledToday: 'Сегодня не по расписанию',
    pause: '⏸️ Пауза',
    resume: '▶️ Возобновить',
    deleteSkill: '🗑️ Удалить',
    // Create Modal
    createSkill: 'Создать пассивный навык',
    buildHabit: 'Создайте новую устойчивую привычку',
    skillName: 'Название навыка *',
    skillNamePlaceholder: 'Например: Утренняя медитация, Ежедневная тренировка...',
    description: 'Описание',
    descriptionPlaceholder: 'Опишите свою привычку и почему она важна...',
    category: 'Категория *',
    icon: 'Иконка *',
    iconPlaceholder: 'Введите эмодзи',
    frequency: 'Частота *',
    daily: 'Ежедневно (Каждый день)',
    weekly: 'Еженедельно (Выбранные дни недели)',
    custom: 'Пользовательские дни (Выберите дни недели)',
    targetDaysPerWeek: 'Целевое количество дней в неделю',
    customDays: 'Выберите дни недели',
    customDaysHelp: 'Засчитываются только выполнения в выбранные дни недели',
    statBoost: 'Улучшаемая характеристика *',
    statBoostDesc: 'Выберите, какую характеристику будет улучшать эта привычка. Вы будете получать пассивные бонусы по мере повышения уровня.',
    howItWorks: 'Как работают пассивные навыки',
    howItWorksDesc1: '• Выполняйте привычку ежедневно для создания серий и повышения уровня (1-10)',
    howItWorksDesc2: '• Более высокие уровни открывают более сильные пассивные бонусы к характеристикам (+0.5% → +10%)',
    howItWorksDesc3: '• Получайте XP, золото и очки характеристик на важных этапах',
    howItWorksDesc4: '• Пассивные бонусы всегда активны и суммируются с другими навыками',
    createButton: 'Создать навык',
    // Milestone Modal
    milestoneReached: 'Этап достигнут!',
    dayStreak: '{value}-дневная серия!',
    levelReached: 'Достигнут уровень {value}!',
    completions: '{value} выполнений!',
    rewards: '🎁 Награды',
    xp: 'XP',
    gold: 'Золото',
    statPoints: 'Очки характеристик',
    newTitle: 'Новый титул разблокирован',
    claimRewards: 'Получить награды',
    theSystem: '— СИСТЕМА',
    // Motivational messages
    streakMessages: [
      'Последовательность — ключ к величию. Продолжайте двигаться вперёд!',
      'Ваша преданность поразительна. Система наблюдает.',
      'Каждый день приближает вас к мастерству. Никогда не сдавайтесь.',
      'Истинная сила исходит из непоколебимой приверженности.',
      'Путь охотника строится день за днём.',
    ],
    levelMessages: [
      'Вы стали сильнее. Ваш пассивный навык эволюционировал.',
      'Обнаружено увеличение силы. Продолжайте тренировки.',
      'Повышение уровня! Ваша дисциплина формирует вашу судьбу.',
      'Система признает ваш прогресс. Отличная работа, Охотник.',
      'С каждым уровнем вы становитесь более грозным.',
    ],
    totalMessages: [
      'Замечательная настойчивость. Вы завершили ещё один этап.',
      'Ваша приверженность непоколебима. Награды отражают ваши усилия.',
      'Выполнение за выполнением, вы создаёте своё наследие.',
      'Система записала ваши достижения. Они не будут забыты.',
      'Каждое выполнение — шаг к тому, чтобы стать легендой.',
    ],
    // Delete confirmation
    deleteConfirm: 'Вы уверены, что хотите удалить этот пассивный навык? Это действие нельзя отменить.',
  },
};

